// Dev-only local auth client (pairs with the backend's LOCAL_AUTH path).
//
// When a local token is present in localStorage, AuthenticatedApi uses it as the
// Bearer token instead of calling Auth0's getAccessTokenSilently — so the ~135
// existing API call sites work unchanged. Register/login pages call the helpers
// below to obtain and store that token.

const TOKEN_KEY = "jcmailer_local_token";

export function getLocalToken() {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    return null;
  }
}

export function setLocalToken(token) {
  window.localStorage.setItem(TOKEN_KEY, token);
}

export function clearLocalToken() {
  window.localStorage.removeItem(TOKEN_KEY);
}

export function isLocalAuthed() {
  return !!getLocalToken();
}

async function postAuth(path, body) {
  const res = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let data = {};
  try {
    data = await res.json();
  } catch (e) {
    // non-JSON (e.g. a 401 "Unauthorized" body); fall through to the status check
  }
  if (!res.ok) {
    // Backend returns { error: "..." }; the 404 case means LOCAL_AUTH is off.
    throw new Error(
      data.error ||
        (res.status === 404
          ? "Local auth endpoint not found — is the backend running with LOCAL_AUTH=true?"
          : `Request failed (${res.status})`)
    );
  }
  if (data.token) setLocalToken(data.token);
  return data;
}

export function registerLocal({ email, password, organizationName }) {
  return postAuth("/api/auth/register", {
    email,
    password,
    organization_name: organizationName,
  });
}

export function loginLocal({ email, password }) {
  return postAuth("/api/auth/login", { email, password });
}
